import { render, staticRenderFns } from "./blog-menu.vue?vue&type=template&id=1f181d9b&scoped=true"
import script from "./blog-menu.vue?vue&type=script&lang=js"
export * from "./blog-menu.vue?vue&type=script&lang=js"
import style0 from "./blog-menu.vue?vue&type=style&index=0&id=1f181d9b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f181d9b",
  null
  
)

export default component.exports